/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';

import { DocSubheaderWrapper } from '../../common/DocSubheaderWrapper/DocSubheaderWrapper';
import { DocumentsAPI } from '../../../api/common/documents';
import { DocumentStatusTag, getTagAttributes } from '../../common/DocumentStatusTag/DocumentStatusTag';
import SigningDocument from '../../common/Documents/SigningDocument';

export namespace DocSubheader {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    selectedDocument: SigningDocument;
    signingAction: DocumentsAPI.ActionResponse;
  }
}
export const docSubheaderHeight = 44;
const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    ...mixins.margin('auto', 0),
    ...mixins.padding(0, 0, 0, 8),
  },
  tagWrapper: {
    ...mixins.marginHorizontal(4),
  },
});

export const DocSubheader: React.SFC<DocSubheader.Props> = ({ selectedDocument, signingAction }) => {
  const statusTagAttributes = getTagAttributes(
    selectedDocument.status,
    !selectedDocument.allowDownload,
    selectedDocument.id === signingAction.document?.id,
    signingAction.type,
    signingAction.signerName,
  );

  return (
    <DocSubheaderWrapper>
      <span className={css(styles.wrapper)} data-it="Notary-DocSubheader">
        {selectedDocument.name}
        {statusTagAttributes && (
          <span className={css(styles.tagWrapper)}>
            <DocumentStatusTag
              indicatorType={statusTagAttributes.indicatorType}
              indicatorText={statusTagAttributes.indicatorText}
            />
          </span>
        )}
      </span>
    </DocSubheaderWrapper>
  );
};
